"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var icons_material_1 = require("@mui/icons-material");
var index_1 = __importDefault(require("../../components/DialogComponent/index"));
var DialogFilterListContainer_styled_1 = require("./DialogFilterListContainer.styled");
var utilities_1 = require("../../utilities");
var react_router_dom_1 = require("react-router-dom");
var react_1 = __importDefault(require("react"));
var DialogFilterListContainer = function (_a) {
    var optionFilterList = _a.optionFilterList, filterList = _a.filterList, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, props = __rest(_a, ["optionFilterList", "filterList", "isLoading"]);
    var _c = (0, react_router_dom_1.useSearchParams)(), searchParams = _c[0], setSearchParams = _c[1];
    var arraySimpleValuesQueryParams = utilities_1.FilterHelper.getSimpleFilterValues(filterList);
    var handleChangeFilter = function (optionsSelected) {
        var filterQueryFormat = optionsSelected.length > 0 &&
            utilities_1.FilterHelper.getFilterSelectedQueryFormat(optionsSelected, filterList);
        for (var _i = 0, _a = Object.keys(filterList); _i < _a.length; _i++) {
            var filterKey = _a[_i];
            for (var _b = 0, _c = filterQueryFormat[filterKey]; _b < _c.length; _b++) {
                var filterValue = _c[_b];
                if (!searchParams.has(filterKey, filterValue))
                    searchParams.append(filterKey, filterValue);
            }
        }
        setSearchParams(searchParams);
    };
    var handleDelete = function (filterValue) {
        if (!filterList)
            return;
        for (var _i = 0, _a = Object.keys(filterList); _i < _a.length; _i++) {
            var filterKey = _a[_i];
            searchParams.delete(filterKey, filterValue);
        }
        setSearchParams(searchParams);
    };
    var handleClear = function () {
        for (var _i = 0, _a = Object.keys(filterList); _i < _a.length; _i++) {
            var filterKey = _a[_i];
            searchParams.delete(filterKey);
        }
        setSearchParams(searchParams);
    };
    return ((0, jsx_runtime_1.jsxs)(index_1.default, __assign({ fullWidth: true }, props, { children: [(0, jsx_runtime_1.jsxs)(DialogFilterListContainer_styled_1.DialogHeader, { children: [(0, jsx_runtime_1.jsx)(DialogFilterListContainer_styled_1.DialogTitleCustom, { children: "Filtros" }), (0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ onClick: props.onClose }, { children: (0, jsx_runtime_1.jsx)(icons_material_1.Close, {}) }))] }), (0, jsx_runtime_1.jsx)(material_1.Paper, __assign({ style: { paddingBottom: '20px' }, elevation: 0 }, { children: (0, jsx_runtime_1.jsx)(material_1.Autocomplete, { multiple: true, freeSolo: true, limitTags: 4, id: "tags-standard", options: optionFilterList, value: optionFilterList.filter(function (op) {
                        return arraySimpleValuesQueryParams.some(function (item) { return item.queryValue === op.dbKey; });
                    }), getOptionLabel: function (option) { return option.value; }, onChange: function (ev, values, reason, detail) {
                        var _a, _b;
                        if (reason === 'selectOption')
                            handleChangeFilter(values);
                        if (reason === 'removeOption')
                            handleDelete((_b = (_a = detail === null || detail === void 0 ? void 0 : detail.option) === null || _a === void 0 ? void 0 : _a.dbKey) !== null && _b !== void 0 ? _b : '');
                        if (reason === 'clear')
                            handleClear();
                    }, groupBy: function (option) { return option.filter.toUpperCase(); }, renderInput: function (params) { return ((0, jsx_runtime_1.jsx)(material_1.TextField, __assign({}, params, { variant: "standard", label: "Agregar filtros", placeholder: "Filtros...", InputProps: __assign(__assign({}, params.InputProps), { endAdornment: ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [isLoading ? ((0, jsx_runtime_1.jsx)(material_1.CircularProgress, { color: "inherit", size: 20 })) : null, params.InputProps.endAdornment] })) }) }))); } }) }))] })));
};
exports.default = DialogFilterListContainer;
